import { urlFor } from "../../../../../lib/sanity";
import { PortableText, toPlainText } from "@portabletext/react";
import Link from "next/link";
import { formatDate, trimText } from "../../../../../common/helper";
import { Meetups } from "../../../../../common/types";

export default function Card({ post }: { post: Meetups }) {
    const {
        title,
        publishedAt,
        mainImage,
        body,
        city,
        slug,
        tags,
        link,
        date,
    } = post;

    return (
        <div className="flex flex-col items-start">
            <Link href={`/meetup/${slug.current}`}>
                <a className="w-full">
                    {mainImage && (
                        <div className="w-full">
                            <img
                                src={urlFor(mainImage)
                                    .size(400, 230)
                                    .fit("crop")
                                    .url()}
                                className="mt-6 mb-6 w-full"
                            />
                        </div>
                    )}
                    <span className="inline-flex items-center text-primary-700 font-medium mb-3">
                        {date ? formatDate(date) : ""} • {city?.title}
                    </span>
                    <h2 className="text-2xl title-font font-medium text-gray-900 mb-2">
                        {title}
                    </h2>
                </a>
            </Link>
            <p className="leading-relaxed mb-6 text-gray-dark">
                {body ? trimText(toPlainText(body as any), 100) + "..." : ""}
            </p>
            <div className="flex">
                {tags?.map((tag) => (
                    <span className="text-green-700 bg-green-100 px-3 py-1 rounded-full text-sm font-medium mr-2">
                        {tag.title}
                    </span>
                ))}
                <span className="text-primary-700 bg-primary-50 px-3 py-1 rounded-full text-sm font-medium">
                    {city?.title}
                </span>
            </div>
        </div>
    );
}
